import React, { useState, useContext } from "react";
import axios, { authIsValid } from "../axios";
import LoginContext from "../context/LoginContext";
import { useNavigate } from "react-router-dom";
import ReactPaginate from "react-paginate";
import Loader from "../components/Loader";
import Delete from "../components/Delete";
import Glogo from "../components/Glogo";

function Formulas() {
  const { isLoggedIn, setIsLoggedIn } = useContext(LoginContext);
  const [category, setCategory] = useState("");
  const [formulas, setFormulas] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [loading, setLoading] = useState(false);
  const [deleteVisibility, setDeleteVisibility] = useState(false);
  const [formulaToDelete, setFormulaToDelete] = useState("");
  const navigate = useNavigate();
  const itemsPerPage = 25;
  const [filteredFormulas, setFilteredFormulas] = useState([]);
  const [currentFormulas, setCurrentFormulas] = useState([]);
  const [pageNumber, setPageNumber] = useState(-1);

  if (isLoggedIn === false) {
    navigate("/mixer");
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSearchValue("");
    setLoading(true);
    try {
      const response = await axios.get(`/formulas/${category}`);

      if (response.data.message) {
        if (authIsValid(response.data.message) === false) {
          navigate("/mixer");
        } else {
          alert(response.data.message);
        }
      } else {
        setFormulas([...response.data]);
        setCurrentFormulas(response.data.slice(0, 25));
        setLoading(false);
      }
    } catch (err) {
      //Some other problem.
      console.error(`Error: ${err}`);
    }
    setPageNumber(0);
    setLoading(false);
    //console.log(currentFormulas);
  };

  const handleSearch = (e) => {
    setSearchValue(e.target.value); //search
    if (e.target.value !== "") {
      const filtered = formulas.filter((formula) => {
        if (formula.color !== undefined) {
          return formula.color.name
            .toUpperCase()
            .includes(e.target.value.toString().toUpperCase());
        }
      });
      //console.log("filtered:", filtered);
      setFilteredFormulas(filtered);
      setCurrentFormulas(filtered.slice(0, 25));
    } else {
      setCurrentFormulas(formulas.slice(0, 25));
    }
    setPageNumber(0);
  };

  const handlePageClick = (e) => {
    if (searchValue === "") {
      const newOffset = (e.selected * itemsPerPage) % formulas.length;
      setCurrentFormulas(formulas.slice(newOffset, newOffset + itemsPerPage));
    } else {
      const newOffset = (e.selected * itemsPerPage) % filteredFormulas.length;
      setCurrentFormulas(
        filteredFormulas.slice(newOffset, newOffset + itemsPerPage)
      );
    }
    setPageNumber(e.selected);
  };

  const handleEdit = (e) => {
    navigate("/editFormula", {
      state: { formulaId: e.target.name, personalFormula: false, category },
    });
  };

  const handleAddNewFormula = () => {
    navigate("/editFormula");
  };

  return (
    <>
      {deleteVisibility && (
        <Delete
          itemId={formulaToDelete}
          itemToDelete={"formula"}
          setVisibility={() => setDeleteVisibility(false)}
          updateList={() => window.location.reload()}
        />
      )}
      <div className="adminHeader">
        <h5 className="futuraBold">Formulas</h5>
      </div>
      <div className="container text-center" style={{ marginTop: 20 }}>
        <div className="row justify-content-center">
          <div className="col-md-10 col-sm-12">
            <form onSubmit={handleSubmit} className="row align-items-center">
              <div className="form-group col-md-6 col-sm-12">
                <label
                  htmlFor="adminCategory"
                  className="col-5 futuraBold"
                  style={{
                    marginRight: 10,
                    padding: "0.375rem",
                    textAlign: "right !important",
                    fontSize: 18,
                  }}
                >
                  Category:
                </label>
                <select
                  id="adminCategory"
                  name="adminCategory"
                  className="form-select input-large"
                  defaultValue=""
                  required
                  onChange={(e) => setCategory(e.target.value)}
                >
                  <option hidden value="">
                    Choose...
                  </option>
                  <option value="UD">Uncoated Direct to Fabric</option>
                  <option value="UB">Uncoated Under Base</option>
                  <option value="CD">Coated Direct to Fabric</option>
                  <option value="CB">Coated Under Base</option>
                  <option value="D">Discharge</option>
                </select>
              </div>
              <div className="col-md-3 col-sm-6">
                <button className="btn btn-ryoForest" type="submit">
                  Load Formulas
                </button>
              </div>
              <div className="col-md-3 col-sm-6">
                <button
                  id="addFormulaButton"
                  className="btn"
                  type="button"
                  style={{
                    color: "#ffffff",
                    backgroundColor: "#000000",
                  }}
                  onClick={handleAddNewFormula}
                >
                  Add New Formula
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div className="col-md-12">
        {loading ? <Loader /> : ""}
        <div id="formulasSearch" className="row justify-content-center">
          <div
            className="form-group col-md-6 col-sm-10"
            style={{ maxWidth: 650 }}
          >
            <label
              htmlFor="searchInput"
              className="col-md-5 col-sm-4 col-form-label futuraBold"
              style={{ textAlign: "center" }}
            >
              Search&nbsp;Formulas
            </label>
            <input
              id="searchInput"
              className="form-control input-lg"
              name="searchInput"
              value={searchValue}
              onChange={handleSearch}
            />
          </div>
        </div>
        <div className="row justify-content-center">
          <div className="col-md-10 col-sm-12">
            <table id="formulasTable" className="table table-striped">
              <thead>
                <tr>
                  <th>Code</th>
                  <th style={{ paddingLeft: 20 }}>Swatch</th>
                  <th>Name</th>
                  <th>Materials</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {currentFormulas &&
                  currentFormulas.map((formula, index) => (
                    <tr key={index}>
                      <td>{formula.code}</td>
                      <td>
                        <Glogo
                          hasStroke={true}
                          size="md"
                          color={
                            formula.color !== undefined
                              ? formula.color.hex
                              : "#ffffff"
                          }
                        />
                      </td>
                      <td>
                        {formula.color !== undefined
                          ? formula.color.name
                          : "No name available"}
                      </td>
                      <td>
                        {formula.materials.map((item) => (
                          <a
                            key={item.material.name + formula._id}
                            href={item.material.url}
                            style={{ marginRight: 5 }}
                          >
                            <Glogo
                              hasStroke={true}
                              size="sm"
                              color={item.material.hex}
                            />
                            {item.material.name},
                          </a>
                        ))}
                      </td>
                      <td align="right">
                        <button
                          className="btn btn-sm editFormula"
                          name={formula._id}
                          type="button"
                          onClick={handleEdit}
                        >
                          Edit
                        </button>
                        <button
                          id={formula._id}
                          className="btn btn-sm deleteFormula"
                          type="button"
                          onClick={(e) => {
                            setFormulaToDelete(e.target.id);
                            setDeleteVisibility(true);
                          }}
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
            {formulas.length === 0 &&
              "Nothing to show. Choose a category and click 'Load Formulas.'"}
          </div>
          <div
            id="pageNumbersContainer"
            className="col-md-4 col-sm-6 col-xs-10 text-center"
          >
            <ReactPaginate
              breakLabel="..."
              nextLabel="next >"
              onPageChange={handlePageClick}
              pageRangeDisplayed={5}
              pageCount={
                searchValue === ""
                  ? Math.ceil(formulas.length / itemsPerPage)
                  : Math.ceil(filteredFormulas.length / itemsPerPage)
              }
              forcePage={pageNumber}
              previousLabel="< prev"
              renderOnZeroPageCount={null}
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default Formulas;
